module.exports = __webpack_public_path__ + "static/media/logojustica.04c2ec8f.svg";